angular.module('kareo.ui.shared.directives.patient-nav.directives', ['kareo.ui.shared.modules.data-filters'])
  .directive('patientInfoWidget', [
    function () {
      function link(scope, element, attrs, PatientInfoWidgetController) {
        PatientInfoWidgetController.init();
      }

      return {
        replace: true,
        restrict: 'E',
        controller: 'PatientInfoWidgetController',
        template: require('./patient-info-widget.pug')(),
        scope: {
          patientId: '@'
        },
        link
      };
    }])
  .directive('kPatientNav', [
    function () {
      function link() {
      }

      return {
        replace: true,
        restrict: 'EA',
        controller: 'kPatientNavController',
        template: require('./k-patient-nav.pug')(),
        scope: {
          patientId: '@'
        },
        link
      };
    }]);
